module.exports = __webpack_public_path__ + "img/puberty-decal-03.9c202ffa.png";